<ul class="list-disc pl-5 mb-2">
  <ng-content></ng-content>
</ul>
